import React from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    Container,
    PageHeader,
    PageContent,
    PageForm,
} from "client/components"


interface AccessDeniedProps {
    tabMode?: boolean
}
const AccessDenied = ({
    tabMode = false,
}: AccessDeniedProps) => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    return (
        <Container>
            {
                !tabMode && (
                    <PageHeader>
                        {lang.accessDeniedHeader}
                    </PageHeader>
                )
            }
            <PageContent>
                <PageForm>
                    {lang.accessDeniedBody}
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default AccessDenied
